import React from 'react'
import { shallow, mount } from 'enzyme'
import IpWhitelistToggle from '../subComponents/IpWhitelistToggle.jsx'

jest.mock('@fortressiq/fiq-ds', () => ({
  useNotification: () => ({
    addNotification: jest.fn(),
  }),
  useModal: () => ({
    addModal: jest.fn(),
    removeModal: jest.fn(),
  }),
  useFela: () => ({
    css: jest.fn(),
    theme: {
      'default-spacer-md': '16px',
      white: '#fff',
    },
  }),
  Button: ({ children, ...props }) => (
    <button type='button' {...props}>
      {children}
    </button>
  ),
  SwitchSection: ({ label, onSwitch, ...props }) => (
    <div {...props}>
      <label>{label}</label>
      <input type='checkbox' onChange={() => onSwitch({ SWITCH_STATE: !props.checked })} />
    </div>
  ),
  Typography: { Text: ({ textToCopy }) => <span>{textToCopy}</span> },
  theme: { 'default-spacer-md': '16px', white: '#fff' },
  Badge: ({ status }) => <span>{status}</span>,
  Popconfirm: ({ children, onConfirm }) => (
    <div>
      {children}
      <button type='button' onClick={onConfirm}>
        Confirm
      </button>
    </div>
  ),
}))

jest.mock('axios', () => ({
  get: jest.fn(() => Promise.resolve({ data: { msg: 'Success' } })),
  post: jest.fn(() => Promise.resolve({ data: { url: 'http://example.com' } })),
  put: jest.fn(() => Promise.resolve({ data: { active: false } })),
  patch: jest.fn(() => Promise.resolve({ data: true })),
}))

jest.mock('lib/Api', () => ({
  post: jest.fn(() => Promise.resolve({ data: { url: 'http://example.com' } })),
  put: jest.fn(() => Promise.resolve({ data: { active: false } })),
  patch: jest.fn(() => Promise.resolve({ data: true })),
}))

jest.mock('../../tenants/SwitchSection', () => ({
  __esModule: true,
  default: jest.fn(() => <div className='switchSection' />),
}))

describe('IP Whitelist Toggle Button Component', () => {
  it('should match snapshot', () => {
    const wrapper = shallow(
      <IpWhitelistToggle
        ipToggleStatus={false}
        whitelistStatus={false}
        handleReFetch={jest.fn()}
        setIpToggleStatus={jest.fn()}
        setWhitelistStatus={jest.fn()}
      />
    )
    expect(wrapper).toMatchSnapshot()
  })

  it('verify toggle with True value', () => {
    const wrapper = mount(
      <IpWhitelistToggle
        ipToggleStatus={true}
        whitelistStatus={true}
        handleReFetch={jest.fn()}
        setIpToggleStatus={jest.fn()}
        setWhitelistStatus={jest.fn()}
      />
    )
    const button = wrapper.find('.ipWhitelistToggle')
    button.props().onSwitch({ SWITCH_STATE: true })
    expect(wrapper.find('.ipWhitelistToggle').props().checked).toBe(true)
  })

  it('verify toggle with False value', () => {
    const wrapper = mount(
      <IpWhitelistToggle
        ipToggleStatus={false}
        whitelistStatus={false}
        handleReFetch={jest.fn()}
        setIpToggleStatus={jest.fn()}
        setWhitelistStatus={jest.fn()}
      />
    )
    const button = wrapper.find('.ipWhitelistToggle')
    button.props().onSwitch({ SWITCH_STATE: false })
    expect(wrapper.find('.ipWhitelistToggle').props().checked).toBe(false)
  })
})
